module.exports = __webpack_public_path__ + "media/images/happy-d297ce8376aa591f025081240d92a26c.svg";